module.exports = __webpack_public_path__ + "static/media/partitions_lcs_60yd_n.e554f8c2.csv";